// extracted by mini-css-extract-plugin
export default {"container":"ReportDeleteModal_container__jK7y+","title":"ReportDeleteModal_title__u5xOX","text":"ReportDeleteModal_text__7xlFM","buttons":"ReportDeleteModal_buttons__0kXyR"};